var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReviewMetaSchema',{attrs:{"itemprop":_vm.SCHEMA_ITEM_PROP.REVIEW_RATING,"itemscope":"","itemtype":_vm.SCHEMA_ITEM_TYPE.RATING,"rating":_vm.rating}})}
var staticRenderFns = []

export { render, staticRenderFns }